import { Anrede, Zahlungsart, Zahlweise } from '@ps20/bff-models';
import { ProgressbarItemsEnum } from '../app/progressbar/data/progressbarItems';
import { Versicherungsnehmer, VnRoleEnum } from './interfaces/versicherungsnehmer';
import { IAppState } from './toolbarState';

const versicherungsnehmer: Versicherungsnehmer = {
  vorname: 'Max',
  nachname: 'Mustermann',
  firmenname: '',
  juristisch: false,
  businessForm: { wert: '', text: '' },
  anrede: Anrede.HERR,
  geburtsdatum: '01.01.1900',
  adresse: {
    strasse: 'Musterstrasse',
    hausnummer: '11',
    ort: 'Musterstadt',
    plz: '12345',
  },
  currentRole: VnRoleEnum.KEIN,
};

export const INITIAL_STATE: IAppState = {
  version: 9,
  versicherungsnehmer,
  aktiveRubrik: ProgressbarItemsEnum.EMPTY,
  rubriken: [],
  accountManager: null,
  speichern: {
    speicherModalOpen: false,
    speicherStatus: 'init',
    vermerk: '',
    vermerkManualInput: false,
    saveAsCopy: false,
  },
  gesamtpreis: 0,
  gesamtpreisHidden: false,
  zahlungsoptionen: {
    zahlungsweise: Zahlweise.MONATLICH,
    zahlungsart: Zahlungsart.LASTSCHRIFT,
  },
  rbd: [],
  rbdModalOpen: false,
  treuebonus: [],
  vorliegendeKuendigungen: [],
  gesamtpreisPopover: {
    gesamtpreisInfoChanged: false,
    gesamtpreisInfoAllowed: false,
    vereinbarungenInfoChanged: false,
  },
  toolbarIsInteractive: true,
  aktionsnachlassCode: {
    code: null,
    name: null,
  },
  transientState: {
    tarifierungIsInProgress: false,
    vorschlagDruckIsInProgress: false,
    shopPricingStale: false,
    isBeibehaltenesProduktInWarenkorb: false,
    beibehaltungAvailable: false,
    openFaq: false,
    modal: {
      modalOpen: false,
      textContent: null,
      styleObject: null,
    },
    featureToggles: {},
    regexps: {},
    zahlungTooltipEnabled: true,
    zahlungTooltipOpen: false,
    vnTooltipEnabled: true,
    vnTooltipOpen: false,
    role: null,
    treuebonusReset: false,
    newsNeusteDate: '',
    newsNeusteRead: false,
    avLoaded: false,
    vermittlernummer: null,
    newsRead: {},
    kooperationen: null,
    tariffUpdatesLatestDate: '',
    tariffUpdatesRead: false,
    cryptId: null,
    isAnfragepflichtigeInformationen: false,
    isTransferToAgentPage: false,
    uwReviewBlocksEditing: false,
  },
  vorteilsrabatt: {
    showKontobewegungen: false,
    gesamtbeitragFuerKunden: 0,
    gesamtDifferenzVertreterkonto: 0,
    produkte: [],
  },
  produkteImAuslandListe: [],
};
